// extracted by mini-css-extract-plugin
export var footer = "_om-5";
export var fulfillmentInput = "_om-0";
export var shipDateInput = "_om-1";
export var shipmentModal = "_om-2";
export var shipmentModalContent = "_om-3";
export var tableContainer = "_om-4";